class DiscountInput extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.button = this.querySelector('button');
        this.input = this.querySelector('input');
        this.invalidFeedback = this.querySelector('.invalid-feedback');
        this.button.addEventListener('click', () => {
            this.invalidFeedback.textContent = '';
            const code = this.input.value.trim().toUpperCase();
            if(code) {
                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        discount: code
                    })
                })
                .then(response => response.json())
                .then(data => {
                    console.log(data);
                    const checkCode = data.discount_codes.find(discount => discount.code == code);
                    if(checkCode.applicable) {
                        document.querySelector('cart-drawer-items').onCartUpdate();
                    } else {
                        this.invalidFeedback.textContent = this.dataset.invalidText || 'Il codice sconto non è valido.';
                    }
                    this.input.value = '';

                });
            }
        });
    }
}

customElements.define('discount-input', DiscountInput);